(ns client-portal.client.concepts.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.amelia-light.components.components :as alc]))

(defn concepts-dropdown [_]
  (let [concepts- (re/subscribe [:concepts/list-data-])
        selected- (re/subscribe [:concepts/selected-])]
    ;; `filter-concept-ids`, when non-empty, restricts the dropdown to only those
    ;; concepts (e.g. a report's `target-concept-ids`). It is destructured out so
    ;; it is not forwarded as an unknown prop to the underlying dropdown.
    (fn [{:keys [on-change filter-concept-ids] :as args}]
      (let [concepts (util/when-not-loading @concepts-)
            on-change (or on-change #(re/dispatch [:concepts/select %]))
            filter-set (when (not-empty filter-concept-ids) (set filter-concept-ids))]
        [alc/up-popover-button-dropdown (merge (dissoc args :filter-concept-ids)
                                               {:placeholder "Concepts"
                                                :search? true
                                                :no-results-message "No concepts found."
                                                :loading (util/loading? concepts)
                                                :on-change (or on-change #(re/dispatch [:concepts/select %]))
                                                :options (some->> (util/when-not-loading concepts)
                                                                  (filter (fn [{:keys [id]}]
                                                                            (or (nil? filter-set) (contains? filter-set id))))
                                                                  (mapv (fn [{:keys [id] :as concept}]
                                                                          {:text (anon.d/concept-label concept)
                                                                           :value id
                                                                           :selected? (= (:id @selected-) id)})))})]))))
